module.exports = __webpack_public_path__ + "img/box_pro_six_1.6723996e.jpg";